import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';
import { Assessment } from '@mui/icons-material';
import SettlementSummaryTable from '../components/SettlementSummaryTable';

const SettlementDashboard: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Paper elevation={3} sx={{ p: 3 }}>
        <Box display="flex" alignItems="center" mb={3}>
          <Assessment sx={{ mr: 2, fontSize: 32, color: 'primary.main' }} />
          <Box>
            <Typography variant="h4" component="h1" gutterBottom>
              Settlement & Reports Dashboard
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              Process daily settlements and view detailed commission reports
            </Typography>
          </Box>
        </Box>

        <SettlementSummaryTable />
      </Paper>
    </Container>
  );
};

export default SettlementDashboard;
